import {
  type CreateOrUpdateQuestCommand,
  postQuests,
  type QuestData,
} from "Infrastructure/Api/Api";
import {
  type ApiCallError,
  processResponse,
} from "Infrastructure/Api/ApiUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { questKeys, questMutationKeys } from "./questKeys";

export const useCreateOrUpdateQuestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<QuestData, ApiCallError, CreateOrUpdateQuestCommand>({
    mutationKey: questMutationKeys.createOrUpdate,
    mutationFn: processResponse((command) => postQuests(command)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: questKeys.lists(),
      });
    },
  });
};
